import { combineEpics } from 'redux-observable';

import { credentialsEpic } from '@bolteu/redux-session';

import { accountEpic } from 'rdx/account/epics';
import { analyticEpic } from 'rdx/analytics/epics';
import { applicationEpic } from 'rdx/application/epics';
import { passwordEpic } from 'rdx/password';
import { promotionsPermissionsEpic } from 'rdx/promotions/epics';
import { sessionEpic } from 'rdx/session/epics';
import { supportEpic } from 'rdx/support';
import { targetingParametersEpic } from 'rdx/targetingParameters/epics';

export const rootEpic = combineEpics(
  accountEpic,
  credentialsEpic,
  passwordEpic,
  supportEpic,
  sessionEpic,
  targetingParametersEpic,
  analyticEpic,
  applicationEpic,
  promotionsPermissionsEpic,
);
